const Config = {
    defaultPath: '/auth/login-page',
    basename: '/',
    layout: 'vertical',
    subLayout: '',
    collapseMenu: false,
    layoutType: 'menu-light',
    headerBackColor: 'header-blue',
    rtlLayout: false,
    navFixedLayout: true,
    headerFixedLayout: false,
    boxLayout: false,
    appsName : 'E-Tirta Medical Centre',
    env: 'production',
    public_url: '/'
};

export default Config;